var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"index"}},[_c('div',{staticClass:"home-content content"},[_c('div',{staticClass:"hc-top clear"},[_c('banner'),_c('search')],1),_c('div',{staticClass:"home-hot clear"},[_c('hot')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }